import { applyRestaurantsWorkingStatusThunk } from '../../redux/thunk/platformWorkingStatus'
import { logger } from '../../logger/logger'

export const processTakeawayMessageThunk = (message) => (dispatch) => {
	switch (message?.type) {
		case 'takeaway-plugin.PLATFORM_WORKING_STATUS_CHANGED':
			dispatch(applyRestaurantsWorkingStatusThunk(message.data))
			break
		default:
			logger.error('Unknown takeaway-plugin message type: ', JSON.stringify(message))
			break
	}
}
